import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { selectAppName } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface CreditCardCapTooltipProps {
  openLeft: boolean
}

const CreditCardCapTooltip: React.FC<CreditCardCapTooltipProps> = (
  props,
): React.ReactElement => {
  const appName = useSelector(selectAppName)
  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            '${creditCardCap} is the max number of credit cards this user can register with ${appName}. This cap is controlled by ${appName}, and can be manually updated by ${appName} upon request (on a case-by-case basis).'
          }
          expressions={{
            creditCardCap: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Credit card cap'} />
              </span>
            ),
            appName: appName,
          }}
        />
      </p>
    </Tooltip>
  )
}

export default CreditCardCapTooltip
